module.exports = __webpack_public_path__ + "static/media/icon_waiting.1d41690a.svg";